export var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["PENDING"] = "PENDING";
    EnrollmentStatus["ACTIVE"] = "ACTIVE";
    EnrollmentStatus["PAUSED"] = "PAUSED";
    EnrollmentStatus["CANCELED"] = "CANCELED";
    EnrollmentStatus["COMPLETED"] = "COMPLETED";
    EnrollmentStatus["EXPIRED"] = "EXPIRED";
})(EnrollmentStatus || (EnrollmentStatus = {}));
export var EnrollmentWorkflowType;
(function (EnrollmentWorkflowType) {
    EnrollmentWorkflowType["EXISTING_SCHEDULES"] = "EXISTING";
    EnrollmentWorkflowType["INLINE_SCHEDULE_CREATION"] = "INLINE";
})(EnrollmentWorkflowType || (EnrollmentWorkflowType = {}));
//# sourceMappingURL=Enrollment.js.map